<form [formGroup]="form">
  <ifc-base-filter-dialog [form]="form" (confirmed)="onConfirmed($event)">
    <ifc-datepicker
      [fc]="form.get('fromDate')"
      [label]="'Transaction date from'"
      [max]="form.get('toDate').value || today"
      baseFilterItem
    ></ifc-datepicker>
    <ifc-datepicker
      [fc]="form.get('toDate')"
      [label]="'Transaction date to'"
      [max]="today"
      [min]="form.get('fromDate').value || null"
      baseFilterItem
    ></ifc-datepicker>
    <mat-form-field appearance="outline" baseFilterItem>
      <mat-label>Include pending transactions</mat-label>
      <mat-select formControlName="includePending">
        <mat-option [value]="true">True</mat-option>
        <mat-option [value]="false">False</mat-option>
      </mat-select>
    </mat-form-field>
  </ifc-base-filter-dialog>
</form>
